// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"165":"41779","313":"db7b9","337":"41779","494":"70370","827":"38edc","902":"b30b4","930":"31d6c","952":"3b687"}[chunkId] + ".bundle.css";
};